import {UIUtils as Parent} from "../../@bizkeytech";
import type {AllToastTypes} from "./type-declerations";
import {AppToastTypes} from "./type-declerations";
import {type Id as ToastId, toast, type ToastOptions} from "react-toastify";

/**
 * Utilities specific for the UI of the project.
 */
class UIUtils extends Parent {

    /**
     * Shows a toast specific for the given [type].
     * @param type      the type of the toast that determines the content to be shown.
     * @param data      the data specific for the toast content.
     * @param options   the options related to the toast itself.
     */
    static toast(type: AllToastTypes, data?: any, options?: ToastOptions): ToastId {
        options = options ?? {};
        let content;
        switch (type) {
            case AppToastTypes.test:
                break;
            default:
                return super.toast(type as any, data, options);
        }
        return toast<any>(content, {
            ...options,
            containerId: options?.containerId ?? this.ToastContainerIDs.default,
            data: data,
        });
    }
}

export * from './type-declerations';
export default UIUtils;
